import React from 'react';
import { SearchIcon, FilterIcon, XIcon } from 'lucide-react';
interface ConnectionsFiltersProps {
  activeFilter: 'all' | 'courses' | 'connected';
  setActiveFilter: (filter: 'all' | 'courses' | 'connected') => void;
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}
const ConnectionsFilters: React.FC<ConnectionsFiltersProps> = ({
  activeFilter,
  setActiveFilter,
  searchQuery,
  setSearchQuery
}) => {
  return <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-705">
      <div className="flex items-center bg-white rounded-lg border border-gray-200 px-3 py-2 w-full md:w-96" data-id="element-706">
        <SearchIcon size={18} className="text-gray-400 mr-2" data-id="element-707" />
        <input type="text" placeholder="Cerca connessioni..." className="bg-transparent border-none outline-none text-sm text-gray-600 w-full" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-708" />
        {searchQuery && <button onClick={() => setSearchQuery('')} className="text-gray-400 hover:text-gray-600" data-id="element-709">
            <XIcon size={16} data-id="element-710" />
          </button>}
      </div>
      <div className="flex overflow-x-auto bg-white rounded-lg border border-gray-200 p-1" data-id="element-711">
        <button className={`px-3 py-2 text-sm font-medium rounded-md whitespace-nowrap ${activeFilter === 'all' ? 'bg-custom-green text-white' : 'text-gray-600 hover:bg-gray-50'}`} onClick={() => setActiveFilter('all')} data-id="element-712">
          Tutte
        </button>
        <button className={`px-3 py-2 text-sm font-medium rounded-md whitespace-nowrap ${activeFilter === 'courses' ? 'bg-custom-green text-white' : 'text-gray-600 hover:bg-gray-50'}`} onClick={() => setActiveFilter('courses')} data-id="element-713">
          Stessi Corsi
        </button>
        <button className={`px-3 py-2 text-sm font-medium rounded-md whitespace-nowrap ${activeFilter === 'connected' ? 'bg-custom-green text-white' : 'text-gray-600 hover:bg-gray-50'}`} onClick={() => setActiveFilter('connected')} data-id="element-714">
          Connessi
        </button>
      </div>
    </div>;
};
export default ConnectionsFilters;